import fetch from '../utils/fetch';
import { harryURL } from 'endpoints';
const HarrySdk = require( '@nackle/harry-sdk' );

function HarryService( accessToken ) {
    const fetchWithAuth = function ( url, options = {} ) {
        options = {
            ...options,
            headers: {
                ...( options.headers || {} ),
                authorization: `Bearer ${ accessToken }`,
            },
        };
        return fetch( url, options );
    };

    const sdk = new HarrySdk( harryURL, fetchWithAuth );

    const getCountryList = async () => {
        try {
            const { countries } = await sdk.getCountries();
            return countries;
        } catch ( error ) {
            console.error( 'ERROR', error );
            throw new Error( 'Unsuccessful response from getCountryList' );
        }
    };

    const getGeographicalRegionList = async ( iso3Code ) => {
        try {
            const { geographicalRegions } = await sdk.getGeographicalRegions( iso3Code );
            return geographicalRegions;
        } catch ( error ) {
            console.error( 'ERROR', error );
            throw new Error( 'Unsuccessful response from getGeographicalRegionList' );
        }
    };

    return {
        getCountryList,
        getGeographicalRegionList
    };
}

export default HarryService;